<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-trade__checklog}">
      <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
      >
      <el-form-item label="仓库：">
          <storages v-model="dataForm.storageId" :defaultItem="null" :autoDefault="true" @change="storageChangeHandle"></storages>
        </el-form-item>
        <el-form-item label="搜索：">
          <el-input
            v-model="dataForm.name"
            placeholder="输入产品名称或规格进行搜索"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="品番号：">
          <el-input
            v-model="dataForm.code"
            placeholder="输入品番号进行搜索"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t("query") }}</el-button>
        </el-form-item>
      </el-form>
      <el-table
        v-loading="dataListLoading"
        :data="dataList"
        border
        @selection-change="dataListSelectionChangeHandle"
        style="width: 100%"
      >
        <el-table-column
          type="index"
          label="#"
          header-align="center"
          align="center"
          width="50"
        ></el-table-column>

        <el-table-column
          prop="code"
          label="品番号"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column label="产品名称" header-align="center" align="center">
          <template slot-scope="scope">
            {{ $productName(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="beforeCount"
          label="盘点前库存"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="afterCount"
          label="盘点后库存"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="storageName"
          label="所属仓库"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="creatorName"
          label="操作人"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="createDate"
          label="操作时间"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="remark"
          label="调整原因"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          :label="$t('handle')"
          fixed="right"
          header-align="center"
          align="center"
          width="150"
        >
          <template slot-scope="scope">
            <el-button
              v-if="$hasPermission('trade:checklog:update')"
              type="text"
              size="small"
              @click="addOrUpdateHandle(scope.row.id)"
              >{{ $t("update") }}</el-button
            >
            <el-button
              v-if="$hasPermission('trade:checklog:delete')"
              type="text"
              size="small"
              @click="deleteHandle(scope.row.id)"
              >{{ $t("delete") }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from "@/mixins/view-module";
export default {
  mixins: [mixinViewModule],
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/trade/checklog/page",
        getDataListIsPage: true,
        activatedIsNeed:false
      },
      dataForm: {
        name: "",
        code:'',
        storageId:''
      },
    };
  },
  components: {},
  methods:{
    storageChangeHandle(){
      this.getDataList()
    }
  }
};
</script>
